export default __webpack_public_path__ + "static/media/3.006d63ae.png";